import React from 'react';
import {useSelector} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button, Col, Form, InputGroup, Row} from "react-bootstrap";
import {faArrowRotateRight} from "@fortawesome/free-solid-svg-icons";
import {Controller, useFormContext, useWatch} from "react-hook-form";
import {selectLang, Translate} from "../../../../../../app/store/reducers/main/mainReducer";

const MassAddRoamingInvoiceImportDetails = ({tableRef, sheetArrayName, skipRowsArrayName, sheetIndex, onResetColumns}) => {
    const specificSheetSkipRowsArrayName = `${skipRowsArrayName}.${sheetIndex}.count_row`;
    const skipRows = useWatch({name: specificSheetSkipRowsArrayName});
    const {setValue, formState: {errors}} = useFormContext();
    const lang = useSelector(selectLang);
    const t = Translate;

    let columnErrors = {};
    if (errors && errors[sheetArrayName] && errors[sheetArrayName][sheetIndex])
        columnErrors = errors[sheetArrayName][sheetIndex];

    const incrementSkipRows = () => {
        setValue(specificSheetSkipRowsArrayName, skipRows + 1);
    };
    const decrementSkipRows = () => {
        setValue(specificSheetSkipRowsArrayName, skipRows - 1);
    };
    const resetColumns = () => {
        onResetColumns();
    }

    const scrollToLeft = () => tableRef.current.scrollLeft -= 400;
    const scrollToRight = () => tableRef.current.scrollLeft += 400;

    return (
        <Row className="p-3">
            <Col xs="12" sm="6" md="auto">
                <Form.Group>
                    <Form.Label>{t(lang, 'roaming.invoice.mass_add.import_details.ignore_top_lines')}</Form.Label>
                    <InputGroup>
                        <Button variant="outline-secondary" onClick={decrementSkipRows}>-</Button>
                        <Controller
                            name={specificSheetSkipRowsArrayName}
                            render={({field}) => (
                                <Form.Control
                                    type="number"
                                    value={field.value}
                                    onChange={field.onChange}
                                    className="input-spin-none"
                                />
                            )}
                        />
                        <Button variant="outline-secondary" onClick={incrementSkipRows}>+</Button>
                    </InputGroup>
                </Form.Group>
            </Col>

            <Col xs="12" sm="auto" className="my-3 ms-sm-auto align-self-end">
                <Button onClick={resetColumns} variant="falcon-warning">
                    <FontAwesomeIcon className="me-2" icon={faArrowRotateRight}/>
                    {t(lang, 'roaming.invoice.mass_add.import_details.reset_columns')}
                </Button>
            </Col>

            <div className="w-100 d-flex flex-between-center my-3">
                <span className="text-danger">{columnErrors?.message}</span>

                <div className="w-50 text-end">
                    <Button variant="falcon-default" className="mx-1" onClick={scrollToLeft}>
                        <FontAwesomeIcon icon="chevron-left"/>
                        <FontAwesomeIcon icon="chevron-left"/>
                    </Button>
                    <Button variant="falcon-default" className="mx-1" onClick={scrollToRight}>
                        <FontAwesomeIcon icon="chevron-right"/>
                        <FontAwesomeIcon icon="chevron-right"/>
                    </Button>
                </div>
            </div>
        </Row>
    );
};

export default MassAddRoamingInvoiceImportDetails;